/* OutIn Malaysia — shared behaviour for outin-* sections.
   Loaded deferred from layout/theme.liquid. No dependencies.
   Respects prefers-reduced-motion and Shopify editor events. */
(function () {
  'use strict';
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- reveal on scroll ---------- */
  var revealObserver = null;
  function ensureObserver() {
    if (revealObserver || reducedMotion.matches || !('IntersectionObserver' in window)) return revealObserver;
    revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    return revealObserver;
  }
  function initReveal(root) {
    var nodes = (root || document).querySelectorAll('.outin-reveal, .outin-stagger');
    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.classList.add('is-visible'); });
      return;
    }
    var io = ensureObserver();
    nodes.forEach(function (n) {
      if (n.classList.contains('is-visible')) return;
      var r = n.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) { n.classList.add('is-visible'); return; }
      io.observe(n);
    });
  }

  /* ---------- hero slider + hero video pause ---------- */
  function setHeroVideos(slider, play) {
    slider.querySelectorAll('video').forEach(function (v) {
      if (play) { v.play().catch(function () {}); } else { v.pause(); }
    });
  }
  function initSliders(root) {
    (root || document).querySelectorAll('[data-outin-slider]').forEach(function (slider) {
      if (slider.dataset.outinInit === 'true') return;
      slider.dataset.outinInit = 'true';
      var slides = Array.prototype.slice.call(slider.querySelectorAll('.outin-hero__slide'));
      var pauseBtn = slider.querySelector('.outin-hero__pause');
      var multi = slides.length > 1;
      var autoplay = slider.dataset.autoplay === 'true' && !reducedMotion.matches && multi;
      var interval = Math.max(3, parseInt(slider.dataset.interval || '6', 10)) * 1000;
      var index = 0, timer = null, paused = !autoplay;
      var dots = Array.prototype.slice.call(slider.querySelectorAll('.outin-hero__dot'));
      function show(i) {
        if (!multi) return;
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) {
          s.classList.toggle('is-active', n === index);
          s.toggleAttribute('aria-hidden', n !== index);
        });
        dots.forEach(function (d, n) { d.setAttribute('aria-current', n === index ? 'true' : 'false'); });
      }
      function tick() { if (!paused) show(index + 1); }
      function start() { stop(); if (autoplay && !paused) timer = setInterval(tick, interval); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function syncPause() {
        if (!pauseBtn) return;
        pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', paused ? pauseBtn.dataset.labelPlay : pauseBtn.dataset.labelPause);
        var play = pauseBtn.querySelector('[data-icon="play"]'), pause = pauseBtn.querySelector('[data-icon="pause"]');
        if (play) play.style.display = paused ? '' : 'none';
        if (pause) pause.style.display = paused ? 'none' : '';
        setHeroVideos(slider, !paused);
        if (paused) stop(); else start();
      }
      dots.forEach(function (d, n) { d.addEventListener('click', function () { paused = true; syncPause(); show(n); }); });
      if (pauseBtn) {
        if (!multi) paused = reducedMotion.matches;
        pauseBtn.addEventListener('click', function () { paused = !paused; syncPause(); });
      }
      if (multi) {
        slider.addEventListener('mouseenter', stop);
        slider.addEventListener('mouseleave', start);
        document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
        show(0);
      }
      if (pauseBtn) syncPause(); else start();
      slider._outinShow = show; slider._outinStop = stop;
    });
  }

  /* ---------- quick add ---------- */
  var toastEl = null, toastTimer = null;
  function toast(message, linkText, linkUrl) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'outin-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '';
    toastEl.appendChild(document.createTextNode(message));
    if (linkText && linkUrl) {
      var a = document.createElement('a');
      a.href = linkUrl; a.textContent = linkText;
      toastEl.appendChild(a);
    }
    requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 4200);
  }
  function updateCartCount() {
    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count], .cart-bubble__text, cart-icon .cart-bubble span[aria-hidden]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { source: 'outin-quick-add', cart: cart } }));
      }).catch(function () {});
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-outin-quickadd]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.dataset.state = 'loading'; btn.setAttribute('aria-busy', 'true'); }
    var fd = new FormData(form);
    fetch(form.action + '.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        updateCartCount();
        toast(form.dataset.addedMessage || 'Added to cart.', form.dataset.viewCartLabel || 'View cart', (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart');
      })
      .catch(function (err) {
        var fallback = function (msg) { toast(msg || form.dataset.errorMessage || 'Could not add to cart.'); };
        if (err && err.json) { err.json().then(function (j) { fallback(j.description || j.message); }).catch(function () { fallback(); }); } else { fallback(); }
      })
      .finally(function () { if (btn) { delete btn.dataset.state; btn.removeAttribute('aria-busy'); } });
  });

  /* ---------- deferred video ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-outin-video-play]');
    if (!btn) return;
    var frame = btn.closest('.outin-video__frame');
    if (!frame) return;
    var video = frame.querySelector('video');
    var embed = frame.dataset.embedUrl;
    if (video) {
      video.hidden = false; btn.remove();
      video.setAttribute('controls', 'controls');
      video.play().catch(function () {});
    } else if (embed) {
      var iframe = document.createElement('iframe');
      iframe.src = embed + (embed.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.setAttribute('allowfullscreen', '');
      iframe.title = frame.dataset.videoTitle || 'Video';
      frame.appendChild(iframe); btn.remove();
    }
  });

  /* ---------- init + Shopify editor events ---------- */
  function initAll(root) { initReveal(root); initSliders(root); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else { initAll(document); }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) {
    e.target.querySelectorAll('.outin-reveal, .outin-stagger').forEach(function (n) { n.classList.add('is-visible'); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest ? e.target.closest('.outin-hero__slide') : null;
    if (!slide) slide = e.target.querySelector && e.target.querySelector('.outin-hero__slide');
    if (slide) {
      var slider = slide.closest('[data-outin-slider]');
      if (slider && slider._outinShow) {
        var slides = Array.prototype.slice.call(slider.querySelectorAll('.outin-hero__slide'));
        slider._outinStop && slider._outinStop();
        slider._outinShow(slides.indexOf(slide));
      }
    }
  });
})();
